import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

function PrivateRoute({ children, allowWithoutTenant = false }) {
  const { isAuthenticated, token, user } = useAuthStore();
  
  // Se não tem token ou não está autenticado, redireciona para login
  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Se não permite acesso sem tenant e usuário não tem tenant, redireciona para welcome
  if (!allowWithoutTenant && !user?.tenant_id) {
    return <Navigate to="/welcome" replace />;
  }
  
  return children;
}

export default PrivateRoute;

